import { createFileRoute, Outlet } from '@tanstack/react-router'
import { purchaseQueryOptions } from '../../../../features/purchasing/queries'

export const Route = createFileRoute('/_app/purchases/$purchaseId')({
  staticData: { crumb: 'purchase' },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(purchaseQueryOptions(params.purchaseId)),
  component: Outlet,
})
